<template>
  <v-layout style="max-height: 90vh">
    <v-content class="conversation-main">
      <v-container
        style="
          max-width: 1000px;
          display: flex;
          flex-direction: column;
          flex: auto;
          min-height: 0;
        "
      >
        <v-layout class="mb-2" style="flex-grow: 0" align-center>
          <h1>Conversation</h1>
          <v-spacer />
        </v-layout>
        <conversation-box
          :selected-conversation-id="selectedConversationId"
          :current-user="currentUser"
          @mark-as-unseen="markAsUnseen"
          :isOpen="true"
          :conversation-page="true"
        />
      </v-container>
    </v-content>
  </v-layout>
</template>

<script>
import moment from 'moment';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import ConversationBox from '@/components/ConversationBox';

export default {
  name: 'Conversation',
  components: {
    ConversationBox,
  },
  data() {
    return {
      previousTitle: '',
      loading: true,
      currentCompanyId: null,
      currentCompany: {
        user: {},
      },
    };
  },
  computed: {
    ...mapState('companies', ['companies']),
    ...mapGetters({
      isFirmCommunicationDisabled: 'isFirmCommunicationDisabled',
      currentUser: 'user',
      clientConversation: 'clientConversation',
      defaultCompany: 'defaultCompany',
    }),
    ...mapGetters(['isAdvisor']),
    selectedConversationId() {
      if (this.loading) {
        return null;
      } else {
        return this.clientConversation.id;
      }
    },
    selectedConversationName() {
      if (this.clientConversation.name) {
        return this.clientConversation.name;
      }
    },
    selectedConversationUsers() {
      if (this.clientConversation.advisor_names) {
        if (this.isAdvisor) {
          return this.clientConversation.client_names
            .filter(u => u !== this.currentUser.full_name)
            .join(', ');
        } else {
          return this.clientConversation.client_names
            .filter(u => u !== this.currentUser.full_name)
            .concat(this.selectedConversation.advisor_names)
            .join(', ');
        }
      }
    },
  },
  methods: {
    moment,
    isEmpty,
    async getClientConversation() {
      const response1 = await API.conversation.getClientConversation(
        this.currentCompanyId,
      );

      if (response1.data.error) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Conversation does not exist.',
        });
        console.log(response1.data.error);
      } else {
        this.$store.dispatch('setClientConversation', response1.data);
        this.loading = false;
      }
    },
    async markAsUnseen() {
      await API.conversation.markAsUnseen(this.selectedConversationId);
    },
  },

  beforeDestroy() {
    document.title = this.previousTitle;
  },

  async created() {
    if (this.isFirmCommunicationDisabled) return this.$router.push('/');

    if (this.$route.query.companyId) {
      this.currentCompanyId = parseInt(this.$route.query.companyId);
    } else if (this.$route.params.hash) {
      const hash = this.$route.params.hash;
      const hashId = hash.substring(hash.lastIndexOf('-') + 1);
      const { data } = await API.company.getCompanyIdByHashId(hashId);

      this.currentCompanyId = data.id;
    } else {
      this.currentCompanyId = this.defaultCompany.id;
    }

    const response = await API.company.getCompany(this.currentCompanyId);
    this.currentCompany = response.data;
    if (isEmpty(this.currentCompany.owner_ids)) {
      this.$store.dispatch('application/setErrorNotification', {
        message:
          'There is no active owner for this entity. Please add an email or an additional owner.',
      });
      this.$router.push(`/admin-dashboard?companyId=${this.currentCompanyId}`);
      return;
    }

    this.previousTitle = document.title;
    document.title = this.currentCompany.name;

    await this.$store.dispatch('resetTiles', {
      hashId: this.currentCompany.hash_id,
      clientName: this.currentCompany.name
        .replaceAll(' ', '-')
        .replaceAll(',', '')
        .replaceAll('#', ''),
    });

    // this.$store.commit('application/START_LOADING');
    if (this.isAdvisor) {
      if (this.currentUser.id === this.currentCompany.user.id) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'You cannot have a conversation with yourself.',
        });

        this.$router.push('/overview');
      } else {
        try {
        } catch (error) {
          console.log(error);
        }
      }
    }

    this.loading = true;
    await this.getClientConversation();
    API.conversation.updateConversationAsSeen(this.selectedConversationId);
    // this.$store.commit('application/END_LOADING');
  },
};
</script>

<style lang="postcss" scoped>
.conversation-main {
  display: flex;
  flex-direction: column;
  flex: auto;
  min-height: 0;

  & >>> .v-content__wrap {
    display: flex;
    flex-direction: column;
    flex: auto;
    min-height: 0;
  }
}
.messages-container {
  padding: 15px;
  border-radius: 8px;
  height: 400px;
  overflow-y: scroll;
}
.message-line {
  &__avatar {
    margin-right: 8px;
    margin-left: 8px;
  }
  &__timestamp {
    font-size: 12px;
    color: #a7a7a7;
  }
  &__text {
    width: 600px;
    border: 2px solid #d7d7d7;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 30px;
    padding-left: 30px;
    border-radius: 8px;
    text-align: left;
    &--user {
      border: 2px solid #e3ebff;
      background-color: #e3ebff;
    }
  }
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  margin-top: 10px;
  margin-bottom: 10px;
}
.message-input {
  margin-left: 15px;
  & >>> .v-input__slot {
    background-color: #f1eded !important;
    border-radius: 10px;
  }
}
.conversation {
  &__container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding-right: 15px;
    padding-left: 15px;
    padding-top: 15px;
    padding-bottom: 15px;
    cursor: pointer;
  }
  &__date {
    display: flex;
    color: #a7a7a7;
    font-size: 11px;
  }
  &__message {
    display: flex;
    color: #373737;
    font-size: 14px;
    align-items: center;
  }
}
</style>
